import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Alert, Button, Col, ColorPicker, Row } from 'antd'
import { BgColorsOutlined } from '@ant-design/icons'
import { Titles } from '../../../layouts/Titles'
import { SectionBadge, FieldBlock } from '../../../components/SectionCard'
import i from '../../../translations/i'
import controller, { THEME_COLORS, THEME_NAMES, ThemeName } from './themes.controller'

const BADGE = 'linear-gradient(135deg, #3f3d56, #63607f)'

const ThemeCard = observer(({ name }: { name: ThemeName }) => (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <SectionBadge icon={<BgColorsOutlined />} text={i.t(`settings:appThemes.${name}`)} background={BADGE} />

        {!controller.exists[name] && <Alert type="info" showIcon message={i.t('settings:appThemes.notCreated')} />}

        <Row gutter={[12, 12]}>
            {THEME_COLORS.map(key => (
                <Col xs={24} sm={12} key={key}>
                    <FieldBlock label={i.t(`settings:appThemes.colors.${key}`)}>
                        <ColorPicker
                            showText
                            disabledAlpha
                            value={`#${controller.themes[name][key]}`}
                            onChange={color => controller.setColor(name, key, color.toHex().slice(0, 6))}
                        />
                    </FieldBlock>
                </Col>
            ))}
        </Row>

        <div>
            <Button type="primary" onClick={() => controller.save(name)}>{i.t('def:actions.save')}</Button>
        </div>
    </div>
))

export const AppThemes = observer(() => {
    useEffect(() => {
        controller.get()
    }, [])

    return (
        <>
            <Titles
                title={i.t('settings:appThemes.title')}
                breadcrumb={[
                    { title: i.t('def:settings'), href: '/settings' },
                    { title: i.t('settings:appThemes.title') },
                ]}
            />

            {controller.loaded &&
                <Row gutter={[32, 32]}>
                    {THEME_NAMES.map(name => (
                        <Col xs={24} xl={12} key={name}>
                            <ThemeCard name={name} />
                        </Col>
                    ))}
                </Row>
            }
        </>
    )
})
